var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Loader",
    _vm._b(
      {
        attrs: {
          "center-top-adjust": _vm.centerTopAdjust,
          "center-left-adjust": _vm.centerLeftAdjust,
        },
        scopedSlots: _vm._u([
          {
            key: "loader",
            fn: function () {
              return [
                _c(
                  "Lottie",
                  _vm._g(
                    _vm._b({}, "Lottie", _vm.$attrs, false),
                    _vm.$listeners
                  )
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "Loader",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }